export class RelatorioDTO<U> {

  manifestos: U[];
  total: number;
  totalPaginado: number;

  constructor() {

    this.manifestos = [];
    this.total = 0;
    this.totalPaginado = 0;

  }

}
